import {
  getPermissions,
  getPerson,
  updateLoggedInUserId,
} from 'actions/loggedInUser/loggedInUserActions';
import { getSettings } from 'actions/settings';
import { getInfo as getCurrentOrganization } from 'actions/currentOrganization';
import { load as getFeatureToggles } from 'actions/featureToggles';
import { fetchPersonApiKeys } from 'actions/personApiKey';
import { getProductTypeInfo } from 'actions/productTypeInfo';
import { loadUserDevices } from 'actions/devices';

function getCommonData({ dispatch, loggedInUserId }) {
  return Promise.all([
    dispatch(getFeatureToggles()),
    dispatch(fetchPersonApiKeys(loggedInUserId)),
    dispatch(getProductTypeInfo()),
  ]);
}

export function initializeApp() {
  return async (dispatch, getState) => {
    const state = getState();
    const {
      loggedInUser: { isTrial, loggedInUserId },
      currentOrganization: { info: currentOrg },
    } = state;

    // Note: we get things if needed since a bunch of the information gets injected in
    // by GWT through global variables. Ideally, in the future, there is no reliance on GWT.
    // and we can unify this function with `initializeEmbeddedApp`
    await Promise.all([
      currentOrg ? null : dispatch(getCurrentOrganization()),
      currentOrg
        ? null
        : dispatch(getSettings('defaults,passwordPolicy,dataLocks,licenses')),
      isTrial ? dispatch(loadUserDevices(loggedInUserId)) : null,
      getCommonData({ dispatch, loggedInUserId }),
    ]);
  };
}

export function initializeEmbeddedApp({ loggedInUserId }) {
  return async dispatch => {
    dispatch(updateLoggedInUserId(loggedInUserId));
    await Promise.all([
      dispatch(getPerson(loggedInUserId)),
      dispatch(getPermissions(loggedInUserId)),
      dispatch(getCurrentOrganization()),
      dispatch(getSettings('defaults,passwordPolicy,dataLocks,licenses')),
      getCommonData({ dispatch, loggedInUserId }),
    ]);
  };
}
